// src/Models/ticketTypeModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID).
// -----------------------------------------------------------------------------

export class TicketTypeModel {
  static typeToFrontend(data) {
    if (!data) return null;
    return {
      ticketTypeID: data.ticketTypeId || data.ticketTypeID,
      typeName: data.typeName,
      status: data.status,
    };
  }

  static typeToBackend(data) {
    if (!data) return null;
    return {
      ticketTypeId: Number(data.ticketTypeID || data.ticketTypeId || 0),
      typeName: data.typeName || '',
      status: data.status || 'Active',
    };
  }

  static subTypeToFrontend(data) {
    if (!data) return null;
    return {
      subTypeID: data.subTypeId || data.subTypeID,
      ticketTypeID: data.ticketTypeId || data.ticketTypeID,
      subTypeName: data.subTypeName,
    };
  }

  static subTypeToBackend(data) {
    if (!data) return null;
    return {
      subTypeId: Number(data.subTypeID || data.subTypeId || 0),
      ticketTypeId: Number(data.ticketTypeID || data.ticketTypeId || 0),
      subTypeName: data.subTypeName || '',
    };
  }
}
